import { FETCH_HEADER_NAVIGATION_FULFILLED, FETCH_HEADER_NAVIGATION_PENDING } from '../actions/getNavigation';
import { FETCH_CUSTOM_NAVIGATION, FETCH_CUSTOM_NAVIGATION_FULFILLED, FETCH_CUSTOM_NAVIGATION_PENDING } from '../actions/getCustomNavigation';
import { SIGN_IN_FULFILLED } from '../actions/signIn';
import { CLEAR_USER_INFO_DATA } from '../actions/clearUserInfoData';

interface ChildPage {
  name: string;
  href: string;
  pageName: string;
  pageURL: string;
}

interface SectionPage {
  name: string;
  childPages: ChildPage[];
}

interface Navigation {
  id?: string;
  url?: string;
  name: string;
  sectionPages?: SectionPage[];
}

export interface TopNavHeaderOptions {
  headerOptions: Navigation[];
  evergreenLinks: EvergreenLink[];
  status?: "PENDING";
}

export interface EvergreenLink {
  id: string;
  name: string;
  href: string;
}

export default function (
  state: TopNavHeaderOptions | null = null,
  action: any
): TopNavHeaderOptions | null {
  switch (action.type) {
    case CLEAR_USER_INFO_DATA:
    case SIGN_IN_FULFILLED: {
      if (action?.payload?.data) {
        const { data } = action.payload;
        if (data?.statusCode === '1009' || data?.statusCode === '1001' || data?.statusCode === '1002') {
          return state;
        }
      }
      return null;
    }
    case FETCH_HEADER_NAVIGATION_PENDING: 
    case FETCH_CUSTOM_NAVIGATION_PENDING: {
      return {
        headerOptions: state?.headerOptions || [],
        evergreenLinks: state?.evergreenLinks || [],
        status: "PENDING"
      }
    }
    case FETCH_HEADER_NAVIGATION_FULFILLED: {
      const navigations: any = [];
      action.payload.data.forEach((navigation: any) => {
        if (
          navigation.displayInNav === 'ALL' ||
          (action.meta.isLoggedIn && navigation.displayInNav === 'AUTH')
        ) {
          const childPages: any = navigation.childPages?.filter(
            (childNav: any) =>
              childNav.displayInNav === 'ALL' ||
              (action.meta.isLoggedIn && childNav.displayInNav === 'AUTH')
          );
          const newNavigation = { ...navigation, childPages };
          navigations.push(newNavigation);
        }
      });
      return navigations;
    }
    case FETCH_CUSTOM_NAVIGATION_FULFILLED: {
      const headerOptionsData = action.payload.data;

      const topNavHeaderLinks = headerOptionsData.filter(
        (obj: any) => !obj.evergreen
      );
      const evergreenLinks = headerOptionsData
        .filter((obj: any) => obj.evergreen)
        .map((evergreenLink: any) => {
          return {
            name: evergreenLink.name,
            id: evergreenLink.contentId,
            href: evergreenLink.url,
          };
        });

      let headerOptions: Navigation[] = topNavHeaderLinks
        .filter((ho: any) => !ho.parent)
        .map((headerOption: any) => {
          return {
            name: headerOption.name,
            sectionPages: [],
          };
        });

      let sectionTitle: { [key: string]: { [key: number]: string } } = {};
      topNavHeaderLinks
        .filter((ho: any) => ho.parent)
        .forEach((data: any) => {
          headerOptions.forEach((topNav: Navigation) => {
            if (topNav.name === data.parent.name) {
              const childPage: any = {};
              childPage.name = data.name;
              childPage.id = data.contentId;
              childPage.href = data.url;
              if (!sectionTitle[data.parent.name]) {
                sectionTitle[data.parent.name] = {};
              }
              sectionTitle[data.parent.name][data.section] = !sectionTitle[data.section]
                ? data.sectionTitle
                : sectionTitle[data.parent.name][data.section];
              if (
                topNav.sectionPages &&
                !topNav.sectionPages[data.section - 1]
              ) {
                topNav.sectionPages[data.section - 1] = {
                  name: topNav.name,
                  childPages: [],
                };
              }
              if (topNav.sectionPages) {
                topNav.sectionPages[data.section - 1].name =
                  sectionTitle[data.parent.name][data.section];
                topNav.sectionPages[data.section - 1].childPages.push(
                  childPage
                );
              }
            }
          });
        });
      return {
        headerOptions,
        evergreenLinks,
      };
    }
    default:
      return state;
  }
}
